/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_Detail_Col_GwInputs */



/**
* | output |
* | --- |
* | "GW" |
*
* @param {User_Detail_Col_GwInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const user_detail_col_gw = /** @type {((inputs?: User_Detail_Col_GwInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Detail_Col_GwInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("GW")
	if (locale === "es") return /** @type {LocalizedString} */ ("GW")
	if (locale === "pt") return /** @type {LocalizedString} */ ("GW")
	if (locale === "it") return /** @type {LocalizedString} */ ("GW")
	return /** @type {LocalizedString} */ ("GW")
});